import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import PersonIcon from '@material-ui/icons/Person';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyAlert from '../AuthBodyAlert';
import AuthBodyContent from '../AuthBodyContent';
import AuthBodyButton from '../AuthBodyButton';
import AuthBodyConfirmation from '../AuthBodyConfirmation';
import AuthBodyActions from '../AuthBodyActions';
import AuthBodyTextFieldRow from '../AuthBodyTextFieldRow';
import AuthBodyTextField from '../AuthBodyTextField';

function ForgotPasswordBody () {
    const authenticity_token = document.querySelector('meta[name=\'csrf-token\']').getAttribute('content');

    const [redirectRoute, setRedirectRoute] = useState('');
    const [email, setEmail] = useState('');
    const [resetRequestSuccess, setResetRequestSuccess] = useState(false);
    const [error, setError] = useState('');

    function handleFormSubmit (e) {
        e.preventDefault();
        const searchParams = new URLSearchParams({
            authenticity_token: authenticity_token,
            utf8: '✓',
            commit: 'SEND me reset password instructions',
            'user[email]': email
        });
        fetch('/user/password', {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            body: searchParams.toString()
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setResetRequestSuccess(true);
                } else {
                    setError('An error occurred while sending your email. Please try again soon.');
                }
            })
            .catch((err) => {
                setError('An error occurred while sending your email. Please try again soon.');
            });
    }

    return (
        <AuthBody onSubmit={handleFormSubmit}>
            { redirectRoute !== '' ? <Redirect to={redirectRoute} /> : null }
            { !resetRequestSuccess ? (
                <>
                    <AuthBodyTitle>
                        Forgot something?
                    </AuthBodyTitle>
                    { error && <AuthBodyAlert severity="error" >{ error }</AuthBodyAlert> }
                    <div>
                        <AuthBodyContent>
                            Enter your account email and we’ll send you a link to reset your password
                        </AuthBodyContent>
                        <AuthBodyTextFieldRow 
                            icon={<PersonIcon color="primary" />}
                        >
                            <AuthBodyTextField
                                fullWidth
                                label="Account Email"
                                color="primary"
                                name="user[email]"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </AuthBodyTextFieldRow>
                    </div>
                    <AuthBodyActions>
                        <AuthBodyButton
                            type="submit"
                        >
                            SEND LINK
                        </AuthBodyButton>
                        <AuthBodyButton
                            variant="outlined"
                            onClick={() => setRedirectRoute('/user/login')}
                        >
                            BACK TO LOGIN
                        </AuthBodyButton>
                    </AuthBodyActions> 
                </>
            ) : (
                <>
                    <AuthBodyTitle>
                        Reset request sent
                    </AuthBodyTitle>
                    <AuthBodyContent>
                        We've sent an email to <strong>{email}</strong>
                        <br />
                        <br />
                        Please follow the instructions to reset your password
                    </AuthBodyContent>
                    <AuthBodyActions>
                        <AuthBodyButton
                            color="primary"
                            variant="outlined"
                            onClick={() => setRedirectRoute('/user/login')}
                        >
                            BACK TO LOGIN
                        </AuthBodyButton>
                        <AuthBodyConfirmation
                            linkText="Resend request"
                            href="#"
                            onLinkClick={() => setResetRequestSuccess(false)}
                        >
                            Didn't recieve an email?
                        </AuthBodyConfirmation>
                    </AuthBodyActions>
                </>
            ) }
        </AuthBody>
    );
}

export default ForgotPasswordBody;